import { App } from 'vue'
import {
  Button,
  List,
  PullRefresh,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Image,
  Form,
  Field,
  NavBar,
  Icon,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Switch,
  Tab,
  Tabs,
  Pagination,
  Popup,
  Calendar,
  NoticeBar,
  Sticky,
  Toast,
  CountDown,
  DatetimePicker,
  ActionSheet,
} from 'vant'

// https://vant-contrib.gitee.io/vant/v3/#/zh-CN
const plugins = [
  Button,
  List,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Image,
  PullRefresh,
  Form,
  Field,
  NavBar,
  Icon,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Switch,
  Tab,
  Tabs,
  Pagination,
  Popup,
  Calendar,
  NoticeBar,
  Sticky,
  Toast,
  CountDown,
  DatetimePicker,
  ActionSheet,
]

export default {
  install(vm: App) {
    plugins.forEach(item => {
      vm.component(item.name, item)
    })
  }
}
